<template lang="pug">
    v-toolbar(dense)
        period-selector(@periodSelected="onPeriodSelected" :periodType="period")
        v-spacer
</template>

<script lang="ts">
import Vue from 'vue'
import PeriodSelector from '@/components/reservation/PeriodSelector.vue'
import { DatePeriod } from '@/model/reservation/DatePeriod'
import { DatePeriodEnum } from '@/types/enums'
import { CUSTOMER_FETCH_CUSTOMER_LIST } from '@/store/action-types'
import Customer from '@/model/customer/Customer'

interface ComponentData {
  isPeriodTypeMonth: boolean
  isPeriodTypeDay: boolean
  period: String
  customerList: Customer[]
  selectedCustomer: Customer | undefined
}

export default Vue.extend({
  name: 'ReservationToolbar',

  components: {
    PeriodSelector
  },

  data (): ComponentData {
    return {
      isPeriodTypeMonth: false,
      isPeriodTypeDay: false,
      period: DatePeriodEnum.Day,
      customerList: [],
      selectedCustomer: undefined
    }
  },

  methods: {
    onPeriodSelected (value: DatePeriod): void {
      this.$emit('periodSelected', value)
    },
  },

  async mounted (): Promise<void> {
    this.customerList = await this.$store.dispatch(CUSTOMER_FETCH_CUSTOMER_LIST)
  }
})
</script>

<style lang="stylus" scoped>
</style>
